import React from "react";
import ShadowCard from "../../../ShadowCard";
import AudioCard from "audiocard";
import "./PodcastPlayer.css";

import { graphql, createFragmentContainer } from "react-relay";
class PodcastPlayer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { title, series, downloadUrl } = this.props.podcast;
    return (
      <div className="podcast-player">
        <ShadowCard width={"100%"} height={"100%"}>
          <AudioCard
            title={title}
            art={series.coverPhoto}
            source={downloadUrl}
            skipBackSeconds={10}
            skipForwardSeconds={30}
          />
        </ShadowCard>
      </div>
    );
  }
}

export default createFragmentContainer(PodcastPlayer, {
  podcast: graphql`
    fragment PodcastPlayer_podcast on PodcastType {
      title
      series {
        coverPhoto
      }
      downloadUrl
    }
  `,
});
